import { uniqueId } from 'lodash-es';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { InfoIcon, StepStatus, Tooltip } from '@dev/ee-components';

import { useCurrentPlanStatus } from '@/services/hooks/useCurrentPlanStatus';
import { getCampainCreatorStore } from '@/store/campaignCreator/actions';
import { CampaignErrorNames } from '@/store/campaignCreator/types';
import { Footer } from '../Footer';
import { useCampaignScreensPathsChecker } from '../hooks/useCampaignScreensPathsChecker';
import { SendTo } from '../SendTo';
import { SettingsAndTracking } from '../SettingsAndTracking';
import { SendToStepTitleWrapper, TooltipIconWrapper } from '../styled';
import { SubjectAndContent } from '../SubjectAndContent';

export const useGetStepsRegular = (): any[] => {
    const { t } = useTranslation();
    const { isPilotPlan } = useCurrentPlanStatus();
    const { errors } = useSelector(getCampainCreatorStore);
    const { isDetailsScreen } = useCampaignScreensPathsChecker();

    const showTooltip = !(isDetailsScreen || isPilotPlan);

    return [
        {
            title: (
                <SendToStepTitleWrapper>
                    {isDetailsScreen ? t('sentto') : t('sendto')}
                    {showTooltip && (
                        <Tooltip id={`step-1-tooltip`} title={t('sendtocampaigncreator_tooltip')}>
                            <TooltipIconWrapper>
                                <InfoIcon />
                            </TooltipIconWrapper>
                        </Tooltip>
                    )}
                </SendToStepTitleWrapper>
            ),
            content: <SendTo />,
            status: 'active',
            hasErrors: errors?.[CampaignErrorNames.TARGETS],
        },
        {
            title: t('subjectandcontent'),
            content: <SubjectAndContent index={0} />,
            status: 'active',
            hasErrors: errors?.[CampaignErrorNames.SUBJECT_AND_CONTENT],
        },
        {
            title: t('settingsandtracking'),
            content: <SettingsAndTracking />,
            isClickable: !isDetailsScreen,
            status: (isDetailsScreen && 'active') || null,
            hasErrors: errors?.[CampaignErrorNames.SETTING_AND_TRACKING],
            errorsId: errors?.[CampaignErrorNames.SETTING_AND_TRACKING] ? uniqueId() : null,
        },
        ...(!isDetailsScreen
            ? [
                  {
                      title: t('save'),
                      content: <Footer />,
                      status: 'content-only' as StepStatus,
                  },
              ]
            : []),
    ];
};
